module.exports = __webpack_public_path__ + "static/media/ml.7582a8b4.svg";